import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectItem } from 'primeng/api/selectitem';
import { of } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { ReportExportViewService } from '../../../../report-export-view.service';
import { Contact } from '../dynamic-contacts.model';

@UntilDestroy()
@Component({
  selector: 'rep-select-contacts',
  templateUrl: './select-contacts.component.html',
  styleUrls: ['./select-contacts.component.scss'],
  standalone: false,
})
export class SelectContactsDialogComponent implements OnInit, OnDestroy {
  public searchUser: UntypedFormControl;
  public contactList: Contact[] = [];
  public selectedContacts: number[] = [];
  public countriesCatalog: SelectItem[] = [];
  public cbreOnly = true;
  public selectedCountry: string;

  constructor(
    public dialogRef: MatDialogRef<SelectContactsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private reportExportViewService: ReportExportViewService,
    private fb: UntypedFormBuilder
  ) {
    this.selectedContacts = this.data.selectedContacts;
  }

  ngOnInit() {
    const { userInfo } = localStorage;
    this.selectedCountry = JSON.parse(userInfo).userCountry;
    this.searchUser = this.fb.control('');
    this.initCountriesCatalog();
    this.searchUser.valueChanges
      .pipe(
        debounceTime(400),
        untilDestroyed(this),
        switchMap((searchString: string) =>
          searchString.trim() !== ''
            ? this.reportExportViewService.searchContact(
                searchString.trim(),
                this.selectedCountry ? '&country=' + this.selectedCountry : '',
                this.cbreOnly ? '&cbreOnly=true' : ''
              )
            : of([])
        )
      )
      .subscribe((contacts: Contact[]) => {
        contacts.forEach(contact => {
          contact.checked = this.selectedContacts.includes(contact.id);
        });
        this.contactList = contacts;
      });
  }
  private initCountriesCatalog() {
    this.reportExportViewService.getCountryList().subscribe(countriesOptions => {
      // map and prepare all the countries options, appending "Unassigned" option
      this.countriesCatalog = (countriesOptions || []).map(country => ({
        label: country.value,
        value: country.value,
      })) as SelectItem[];
    });
  }

  catalogSelection({ value }) {
    this.selectedCountry = value;
    this.searchContacts();
  }

  searchContacts() {
    this.reportExportViewService
      .searchContact(
        this.searchUser.value.trim(),
        this.selectedCountry ? '&country=' + this.selectedCountry : '',
        this.cbreOnly ? '&cbreOnly=true' : ''
      )
      .subscribe((contacts: Contact[]) => {
        contacts.forEach(contact => {
          contact.checked = this.selectedContacts.includes(contact.id);
        });
        this.contactList = contacts;
      });
  }

  ngOnDestroy() {
    /* required by untilDestroyed and angular-l10n */
  }

  contactChecked(status: boolean, id: number) {
    if (status) {
      this.selectedContacts.push(id);
    } else {
      const index = this.selectedContacts.findIndex(a => a === id);
      this.selectedContacts.splice(index, 1);
    }
  }

  onCreate() {
    this.dialogRef.close(this.selectedContacts);
  }

  onClose() {
    this.dialogRef.close();
  }
}
